import { narApiService, narService, type NarSwitchAppInstancePayload } from '@/modules/nar';
import { type InstallerGetDataParams } from '../types';
import { DeviceInstaller } from '../interfaces/DeviceInstaller';

const DmInstaller: DeviceInstaller = {
  getData(params: InstallerGetDataParams) {
    return Promise.all([
      narApiService.getAppConfig(params),
      narApiService.getMasterInstanceData(),
    ]).then((res) => ({
      appConfig: {
        data: res[0].data,
      },
      device: {
        data: res[1].data,
      },
    })).finally(() => {
      narService.startNarKeepAlive();
    });
  },
  run() {
    return Promise.resolve();
  },
  switchUpperScreen(accountId) {
    const payload: NarSwitchAppInstancePayload = {};

    if (accountId !== 'home') {
      payload.cpvUuid = accountId;
    } else {
      payload.window_title = accountId;
    }

    return narApiService.switchAppInstance(payload);
  },
};

export {
  DmInstaller,
};
